import React from 'react';
import { Linkedin, Twitter, Github, Mail } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="py-12 border-t border-border bg-base" data-id="element-112">
      <div className="container mx-auto px-6 md:px-12" data-id="element-113">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-114">
          <div data-id="element-115">
            <Logo className="mb-3" onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })} data-id="element-116" />
            <span className="text-sm text-secondary font-mono" data-id="element-117">
              Engineering Leadership Advisor • CEO, Waydev
            </span>
          </div>

          <div className="flex items-center gap-6" data-id="element-118">
            <a href="https://linkedin.com/in/alexcircei" target="_blank" rel="noopener noreferrer" className="text-muted hover:text-accent transition-colors" data-id="element-119">
              <Linkedin className="w-5 h-5" data-id="element-120" />
              <span className="sr-only" data-id="element-121">LinkedIn</span>
            </a>
            <a href="https://x.com/alexcircei" target="_blank" rel="noopener noreferrer" className="text-muted hover:text-accent transition-colors" data-id="element-122">
              <Twitter className="w-5 h-5" data-id="element-123" />
              <span className="sr-only" data-id="element-124">X (Twitter)</span>
            </a>
            <a href="https://github.com/alexcircei" target="_blank" rel="noopener noreferrer" className="text-muted hover:text-accent transition-colors" data-id="element-125">
              <Github className="w-5 h-5" data-id="element-126" />
              <span className="sr-only" data-id="element-127">GitHub</span>
            </a>
            <a href="mailto:alex.circei@gmail.com" className="text-muted hover:text-accent transition-colors" data-id="element-128">
              <Mail className="w-5 h-5" data-id="element-129" />
              <span className="sr-only" data-id="element-130">Email</span>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border/50 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted" data-id="element-131">
          <p data-id="element-132">© {new Date().getFullYear()} Alex Circei. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-133">
            <a href="#" className="hover:text-secondary transition-colors" data-id="element-134">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-secondary transition-colors" data-id="element-135">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}